import axios from 'axios';
import { useState } from 'react';

import { TABLET_API_ORIGIN } from '@/global/env';
import { downloadFileFromResponse } from '@/lib/util';

export const useMenuManagementDownloadBrandItems = (params: {
  associateBrandId: string;
  onlyHeader?: boolean;
}) => {
  const [loading, setLoading] = useState(false);
  const downloadCSV = async (): Promise<void> => {
    setLoading(true);
    downloadBrandItems({ ...params, setLoading });
  };
  return { downloadCSV, loading };
};

const downloadBrandItems = async ({
  associateBrandId,
  onlyHeader,
  setLoading,
}: {
  associateBrandId: string;
  onlyHeader?: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  try {
    const params = new URLSearchParams();
    params.append('associate_brand_id', associateBrandId);
    params.append('only_header', `${onlyHeader || false}`);

    const response = await axios.get(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-items/download?${params.toString()}` as const,
      {
        withCredentials: true,
      }
    );
    downloadFileFromResponse(response);
  } catch (error) {
    // @ts-ignore TS2590
    if (error.isAxiosError) {
      // @ts-ignore TS2590
      alert(error.response.data.message);
    } else {
      alert((error as Error).message);
    }
  } finally {
    setLoading(false);
  }
};
